module.exports = __webpack_public_path__ + "img/event_user_report_unpublished_changes.795457f4.svg";